export enum SpecialityCategory {
  NotSet = 1,
  Anaesthetics = 2,
  Surgery = 4
}
